export default "__VITE_ASSET__BbNWYfM$__"